import React, { memo, useCallback } from 'react'

import { Checkbox } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { getLibraryFilterUpdaterFunction } from 'Pods/ThreeDStudio/Shared/Utils'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { GENERATED_FILTERS } from 'Pods/ThreeDStudio/Store/actions/filters'

function FilteringCheckbox({ id, keyName, label }) {
  const isChecked = useThreeDStudioStore(state => {
    if (keyName === 'generated') {
      return GENERATED_FILTERS.some(filter => state.libraryFilter.includes(filter))
    }

    return state.libraryFilter.includes(keyName)
  })

  const handleChange = useCallback(value => {
    getLibraryFilterUpdaterFunction(value)(keyName)
  }, [])

  return (
    <Checkbox
      id={id}
      label={label}
      isChecked={isChecked}
      isControlled
      onChange={handleChange}
      checkedColor="primary"
      size="small"
    />
  )
}

FilteringCheckbox.propTypes = {
  id: string.isRequired,
  keyName: string.isRequired,
  label: string.isRequired,
}

export default memo(FilteringCheckbox)
